import { createSelector } from 'reselect';
import { createFeatureSelector } from 'features/create-feature-selector';

const featureRootSelector = createFeatureSelector('trustDocuments');

const getTrustDocuments = createSelector(
  featureRootSelector,
  (state) => state || { data: null, loading: false, error: null },
);

export const getTrustDocumentsData = createSelector(getTrustDocuments, (state) => state.data);
export const getTrustDocumentsLoading = createSelector(getTrustDocuments, (state) => state.loading);
export const getTrustDocumentsError = createSelector(getTrustDocuments, (state) => state.error);

export const getTrustMerchant = createSelector(getTrustDocumentsData, (data) => data?.merchant);
export const getIsAllowedToSellMarkingProducts = createSelector(
  getTrustDocumentsData,
  (data) => data?.merchant.isAllowedToSellMarkingProducts,
);
export const getTrustDocumentsList = createSelector(getTrustDocumentsData, (data) => data?.documents ?? []);
